import { useEffect, useState } from "react";

import { useResolutionsApi } from "../../../../../common/api/orders-api/resolution/useResolutionsApi";
import { formOptionsLoader } from "../../../../../common/components/form/FormOptionsLoader";
import { Resolution } from "../../../../common/types/Resolution";

export const useResolutionOptions = () => {
    const { getResolutionList } = useResolutionsApi();

    const [resolutions, setResolutions] = useState<Resolution[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    const loadResolutionOpts = (): void => formOptionsLoader(getResolutionList, setIsLoading, setResolutions);

    useEffect(() => {
        loadResolutionOpts();
    }, []);

    return {
        resolutions,
        isLoading
    };
};
